(() => {
  const root = document.querySelector('[data-an-shanghai]');
  if (!root) return;

  const guideMap = {
    daniel: { name: 'Daniel', code: 'DANIEL10' },
    hill: { name: 'Hill', code: '' },
  };
  const storageKey = 'an_referral_source';
  const params = new URLSearchParams(window.location.search);
  const incomingRef = (params.get('ref') || '').trim().toLowerCase();
  let storedRef = '';

  try {
    storedRef = (localStorage.getItem(storageKey) || '').toLowerCase();
  } catch (_error) {
    storedRef = (sessionStorage.getItem(storageKey) || '').toLowerCase();
  }

  const ref = guideMap[incomingRef] ? incomingRef : (guideMap[storedRef] ? storedRef : '');
  const guide = guideMap[ref];

  if (guide) {
    try {
      localStorage.setItem(storageKey, ref);
    } catch (_error) {
      sessionStorage.setItem(storageKey, ref);
    }
    const banner = root.querySelector('[data-guide-benefit]');
    const text = root.querySelector('[data-guide-benefit-text]');
    if (guide.code && banner && text) {
      text.textContent = `${guide.name}’s guest benefit · 10% off`;
      banner.hidden = false;
    }

    const syncReferralToCart = () => fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: {
        referral_source: ref,
      }}),
    }).catch(() => {});

    syncReferralToCart();
    root.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
      form.addEventListener('submit', syncReferralToCart, { capture: true });
    });
  }

  document.addEventListener('cart:updated', () => {
    const mobileLink = root.querySelector('[data-mobile-cta] a');
    if (!mobileLink) return;
    mobileLink.href = '/cart';
    mobileLink.textContent = 'VIEW CART';
  });
})();
